import { useEffect, useState } from "react";
import api from "@/api/client";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Sparkles } from "lucide-react";
import { toast } from "sonner";

export default function SubmitToDropButton({ product, vendorId }) {
  const [open, setOpen] = useState(false);
  const [drops, setDrops] = useState([]);
  const [selected, setSelected] = useState("");
  const [price, setPrice] = useState(String(product?.price || ""));
  const [qty, setQty] = useState("10");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!open) return;
    api.get("/drops/active").then((r) => {
      const list = (r.data || []).filter((d) => d.state !== "ended");
      setDrops(list);
      if (list[0]) setSelected(list[0].id);
    });
  }, [open]);

  const submit = async () => {
    if (!selected) return toast.error("Pick a drop");
    setBusy(true);
    try {
      await api.post(`/exhibitor/drops/${selected}/submit`, { product_id: product.id, drop_price: Number(price), quantity: Number(qty) });
      toast.success("Submitted for admin approval");
      setOpen(false);
    } catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button data-testid={`submit-drop-${product.id}`} className="text-xs text-[#F48E2E] hover:text-[#D97815] flex items-center gap-1 font-medium">
          <Sparkles className="h-3 w-3" /> Submit for Drop
        </button>
      </DialogTrigger>
      <DialogContent data-testid="submit-drop-dialog">
        <DialogHeader><DialogTitle>Submit {product.name} for a Drop</DialogTitle></DialogHeader>
        {drops.length === 0 ? (
          <div className="text-sm text-gray-500">No drops open for submissions right now. Check back when Admin invites you to one.</div>
        ) : (
          <div className="space-y-3">
            <div>
              <div className="text-[11px] uppercase tracking-widest text-gray-500 font-semibold mb-1">Drop</div>
              <select value={selected} onChange={(e) => setSelected(e.target.value)} className="w-full h-10 rounded-xl border border-gray-300 px-3 text-sm bg-white">
                {drops.map((d) => <option key={d.id} value={d.id}>{d.name} · {d.state}</option>)}
              </select>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div><div className="text-[11px] uppercase tracking-widest text-gray-500 font-semibold mb-1">Drop price</div><Input data-testid="submit-drop-price" type="number" value={price} onChange={(e) => setPrice(e.target.value)} /></div>
              <div><div className="text-[11px] uppercase tracking-widest text-gray-500 font-semibold mb-1">Quantity</div><Input data-testid="submit-drop-qty" type="number" value={qty} onChange={(e) => setQty(e.target.value)} /></div>
            </div>
            <div className="text-[11px] text-gray-500">Admin will review your submission before it appears in the drop.</div>
            <Button data-testid="submit-drop-btn" onClick={submit} disabled={busy} className="w-full rounded-full bg-[#F48E2E] hover:bg-[#D97815]">{busy ? "Submitting…" : "Submit for review"}</Button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
